module.exports = __webpack_public_path__ + "static/img/rank_120.e47ec55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_120.png
// module id = 3asi
// module chunks = 0